import { Button } from 'primereact/button';
import { MenuItem } from 'primereact/menuitem';
import { TieredMenu } from 'primereact/tieredmenu';
import { Toast } from 'primereact/toast';
import { FC, RefObject, useRef } from 'react';

interface Props {
  studentsToCopy: { fullName: string; publicUserId: string }[];
  menuRef: RefObject<TieredMenu>;
}

const ExitSlipCopyStudentList: FC<Props> = ({ studentsToCopy, menuRef }) => {
  const toast = useRef<Toast>(null);

  const handleCopy = async () => {
    try {
      const userNamestoString: string | undefined = studentsToCopy
        ?.map(user => {
          return user.fullName;
        })
        .join(', ');
      if (userNamestoString) {
        await navigator.clipboard.writeText(userNamestoString);
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Users have been copied to clipboard!',
          life: 3000,
        });
      }
    } catch (_error) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Users have not been copied to clipboard',
        life: 3000,
      });
    }
  };

  const items = [
    {
      label: 'Copy list of students',
      icon: 'nc_icon-nc_copy icon-sm',
      template: (item: MenuItem) => (
        <Button
          icon={`${item.icon}`}
          label={`${item.label}`}
          onClick={handleCopy}
          className="nc_metergroup-button"
          style={{ width: '100%' }}
        />
      ),
    },
    ...studentsToCopy.map(el => ({
      label: el.fullName ?? '',
      className: 'ph-no-capture',
    })),
  ];

  return (
    <>
      <TieredMenu model={items} popup ref={menuRef} breakpoint="767px" />
      <Toast ref={toast} position="top-right" appendTo={document.body} />
    </>
  );
};

export default ExitSlipCopyStudentList;
